import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { Icon } from '../Icon';
export type StarRatingSize = Extract<SizesType, 'sm' | 'xs'>;
interface Props {
  /** Pass through className to allow styles overrides */
  className?: string;
  /** The number of stars to show */
  rating: number;
  /** The size of the stars */
  size?: StarRatingSize;
  /** Whether it should render inline StartRating */
  isInline?: boolean;
  wrapperId?: string;
}
const IconsWrapper = /*#__PURE__*/styled('div')({
  name: "IconsWrapper",
  class: "i14uvc9o",
  propsAsIs: false
});
export const StarRating = ({
  rating,
  size = 'sm',
  isInline = false,
  className,
  wrapperId
}: Props) => {
  return <IconsWrapper className={cx(isInline && 'isInline', className)} id={wrapperId}>
      {Boolean(rating) && new Array(Math.floor(rating)).fill('x').map((_, index) => <Icon key={`star-${index}-${size}`} size={size} name="StarSolid" colorPath="starRating.content" />)}
    </IconsWrapper>;
};

require("./StarRating.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./StarRating.tsx");